import { render, staticRenderFns } from "./BarChart.htm?vue&type=template&id=9de35da2&"
import script from "./BarChart.ts?vue&type=script&lang=js&"
export * from "./BarChart.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports